import React from 'react';

export type SealIconName =
  | 'medal'
  | 'shield-check'
  | 'lock'
  | 'bell'
  | 'book'
  | 'bookmark'
  | 'calendar'
  | 'check'
  | 'check-circle'
  | 'arrow-right'
  | 'arrow-left'
  | 'clipboard'
  | 'clock'
  | 'code'
  | 'alert-sign'
  | 'heart';

const base = { xmlns: 'http://www.w3.org/2000/svg', fill: 'none', viewBox: '0 0 24 24', stroke: 'currentColor' } as const;

export const MedalIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <circle cx="12" cy="10" r="4" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 14l-2 6 5-3 5 3-2-6" />
  </svg>
);

export const ShieldCheckIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l7 4v5c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V7l7-4z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.5 12.5l2 2 3.5-3.5" />
  </svg>
);

export const ShieldLockIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3l7 4v5c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V7l7-4z" />
    <rect x="9" y="11" width="6" height="5" rx="1.5" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 11V9a3.5 3.5 0 017 0v2" />
  </svg>
);

export const LockIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 11V8a4 4 0 118 0v3" />
  </svg>
);

export const BellIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 22a2 2 0 002-2H10a2 2 0 002 2z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M18 16v-5a6 6 0 10-12 0v5l-2 2h16l-2-2z" />
  </svg>
);

export const BookIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 19V5a2 2 0 012-2h9a2 2 0 012 2v14H6a2 2 0 00-2 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6" />
  </svg>
);

export const BookmarkIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 3h12v18l-6-3-6 3V3z" />
  </svg>
);

export const CalendarIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 3v4M8 3v4M3 9h18" />
  </svg>
);

export const CheckIcon2: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={3}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

export const CheckCircleIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <circle cx="12" cy="12" r="9" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.5 12.5l2.5 2.5 4.5-4.5" />
  </svg>
);

export const ArrowRightIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h12M13 5l7 7-7 7" />
  </svg>
);

export const ArrowLeftIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 12H7M11 5l-7 7 7 7" />
  </svg>
);

export const ClipboardIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <rect x="7" y="4" width="10" height="16" rx="2" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 4h6v3H9z" />
  </svg>
);

export const ClockIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <circle cx="12" cy="12" r="9" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 7v6l4 2" />
  </svg>
);


export const CodeIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 18l-6-6 6-6M15 6l6 6-6 6" />
  </svg>
);

export const AlertSignIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4l8 14H4l8-14z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4" />
    <circle cx="12" cy="15.5" r="1" />
  </svg>
);

export const HeartIcon: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg {...base} className={className} style={style} strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s-6-3.5-8.5-6C1.5 13 2 9.5 4.5 8A4.6 4.6 0 0112 9a4.6 4.6 0 017.5-1c2.5 1.5 3 5 0.5 7-2.5 2.5-8.5 6-8.5 6z" />
  </svg>
);

export const SEAL_ICONS: Record<SealIconName, React.FC<{ className?: string; style?: React.CSSProperties }>> = {
  'medal': MedalIcon,
  'shield-check': ShieldCheckIcon,
  'lock': LockIcon,
  'bell': BellIcon,
  'book': BookIcon,
  'bookmark': BookmarkIcon,
  'calendar': CalendarIcon,
  'check': CheckIcon2,
  'check-circle': CheckCircleIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-left': ArrowLeftIcon,
  'clipboard': ClipboardIcon,
  'clock': ClockIcon,
  'code': CodeIcon,
  'alert-sign': AlertSignIcon,
  'heart': HeartIcon,
};